import React from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  FormFeedback
} from 'reactstrap';
import withValidation from '../withValidation';
import styles from './styles.scss';


class NumericInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const { onChange } = this.props;
    if (onChange) {
      onChange(event.target.value);
    }
  }

  render() {
    const {
      value,
      invalid,
      error,
      disabled,
      onBlur,
      step,
      placeholder
    } = this.props;

    return [
      <Input className={styles.input}
        key='input'
        value={value}
        type={'number'}
        onChange={this.onChange}
        onBlur={onBlur}
        step={step}
        invalid={invalid}
        disabled={disabled}
        placeholder={placeholder}
        // onInput={(event) => this.enterScore(event, index)}
      />,
      <FormFeedback
        key='feedback'
        className='text-left'
      >
        {error}
      </FormFeedback>
    ];
  }
}

NumericInput.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  step: PropTypes.string,
  error: PropTypes.string,
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string
};


export default withValidation(NumericInput);



// WEBPACK FOOTER //
// src/components/shared/NumericInput/index.jsx